import Grid from '@material-ui/core/Grid';
import { createStyles, withStyles } from '@material-ui/styles';
import * as React from 'react';
import { compose, pure } from 'recompose';
import { Select, SelectItem } from '../../Select';
const styles = () => createStyles({
    dropdown: {
        maxHeight: 360,
    },
});
const MONTHS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
const YEAR_OFFSET = 10;
const DatePickerMonthYearSelection = ({ classes, classNames, date, onChange, t, }) => {
    const currentYear = new Date().getFullYear();
    const selectedYear = date.getFullYear();
    const years = React.useMemo(() => {
        const yearsArray = [];
        if (selectedYear < currentYear - YEAR_OFFSET) {
            yearsArray.push(selectedYear);
        }
        for (let year = currentYear - YEAR_OFFSET; year <= currentYear + YEAR_OFFSET; year += 1) {
            yearsArray.push(year);
        }
        if (selectedYear > currentYear + YEAR_OFFSET) {
            yearsArray.push(selectedYear);
        }
        return yearsArray;
    }, [currentYear, selectedYear]);
    const handleChangeMonth = React.useCallback((event) => {
        const { target: { value: month }, } = event;
        onChange(new Date(date.getFullYear(), month));
    }, [date, onChange]);
    const handleChangeYear = React.useCallback((event) => {
        const { target: { value: year }, } = event;
        onChange(new Date(year, date.getMonth()));
    }, [date, onChange]);
    return (React.createElement("section", { className: classNames.caption },
        React.createElement(Grid, { container: true, spacing: 1 },
            React.createElement(Grid, { item: true, xs: 4 },
                React.createElement(Select, { input: { onChange: handleChangeMonth, value: date.getMonth() }, label: "", meta: {}, name: "month" }, MONTHS.map((month) => {
                    return (React.createElement(SelectItem, { key: month, value: month }, t('dates:monthsShort')[month]));
                }))),
            React.createElement(Grid, { item: true, xs: 4 },
                React.createElement(Select, { input: { onChange: handleChangeYear, value: date.getFullYear() }, label: "", MenuProps: {
                        classes: {
                            paper: classes.dropdown,
                        },
                    }, meta: {}, name: "year" }, years.map((year) => {
                    return (React.createElement(SelectItem, { key: year, value: year }, year));
                }))))));
};
const ComposedDatePickerMonthYearSelection = compose(pure, withStyles(styles, { withTheme: true }))(DatePickerMonthYearSelection);
DatePickerMonthYearSelection.displayName = 'DatePickerMonthYearSelection';
export default ComposedDatePickerMonthYearSelection;
//# sourceMappingURL=DatePickerMonthYearSelection.js.map